import { Banner, Flex } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

export const InitFailedState = () => {
  const { t } = useTranslation('common');

  return (
    <Flex width="100%" justifyContent="center" mt="10rem">
      <Banner
        id="init-failed-banner"
        isFlat
        intent="error"
        title={t('errors.initFailed.title')}
        message={t('errors.initFailed.message')}
        cta={t('errors.initFailed.reload')}
        onClickCta={() => window.location.reload()}
      />
    </Flex>
  );
};
